import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { BATCH_PROCESSING_ROUTE_PATHS } from './config';

export const BATCH_PROCESSING_ROUTES: TApplicationRoute[] = [
  {
    id: 'batch-processing',
    path: BATCH_PROCESSING_ROUTE_PATHS.batchProcessing,
    component: lazy(() => import('./pages/batch-processing-page')),
    layout: 'default',
    permissions: { scopes: ['batch-processing'] },
    menu: {
      title: 'pages.batchProcessing.title',
    },
  },
];
